<template>
	<div class="main">
		<div class="body-main">

			<div class="bodycate" :class="{'dark':themeName=='dark'}">
				<router-link to="/c1">三洞真经</router-link>
			</div>
			<div class="bodycatef">
				<ul class="indexcateul">
					<li>
						<router-link to="/c8">洞真上清经</router-link>
					</li>
					<li>
						<router-link to="/c9">洞玄灵宝经</router-link>
					</li>
					<li>
						<router-link to="/c10">洞神三皇经</router-link>
					</li>
					<li>
						<router-link to="/c11">三洞经教</router-link>
					</li>
				</ul>
			</div>
			<div class="bodycate" :class="{'dark':themeName=='dark'}">
				<router-link to="/c2">四辅真经</router-link>
			</div>
			<div class="bodycatef">
				<ul class="indexcateul">
					<li>
						<router-link to="/c12">太平部诸经</router-link>
					</li>
					<li>
						<router-link to="/c13">太玄部经诀</router-link>
					</li>
					<li>
						<router-link to="/c14">正一部经籙</router-link>
					</li>
					<li>
						<router-link to="/c15">道德真经</router-link>
					</li>
					<li>
						<router-link to="/c16">四子真经</router-link>
					</li>
					<li>
						<router-link to="/c17">黄帝阴符经</router-link>
					</li>
					<li>
						<router-link to="/c18">道教易学</router-link>
					</li>
					<li>
						<router-link to="/c19">太清金丹经</router-link>
					</li>
					<li>
						<router-link to="/c20">太清摄养经</router-link>
					</li>
				</ul>
			</div>
			<div class="bodycate" :class="{'dark':themeName=='dark'}">
				<router-link to="/c3">道教论集</router-link>
			</div>
			<div class="bodycatef">
				<ul class="indexcateul">
					<li>
						<router-link to="/c21">诸子文集</router-link>
					</li>
					<li>
						<router-link to="/c22">道学论著</router-link>
					</li>
					<li>
						<router-link to="/c23">全真文集</router-link>
					</li>
					<li>
						<router-link to="/c24">道教类书</router-link>
					</li>
				</ul>
			</div>
			<div class="bodycate" :class="{'dark':themeName=='dark'}">
				<router-link to="/c4">道法众术</router-link>
			</div>
			<div class="bodycatef">
				<ul class="indexcateul">
					<li>
						<router-link to="/c25">道法诸经</router-link>
					</li>
					<li>
						<router-link to="/c26">道法总集</router-link>
					</li>
				</ul>
			</div>
			<div class="bodycate" :class="{'dark':themeName=='dark'}">
				<router-link to="/c5">道教科仪</router-link>
			</div>
			<div class="bodycatef">
				<ul class="indexcateul">
					<li>
						<router-link to="/c27">科戒威仪</router-link>
					</li>
					<li>
						<router-link to="/c28">灵宝诸斋仪</router-link>
					</li>
					<li>
						<router-link to="/c29">灯仪法忏章表</router-link>
					</li>
				</ul>
			</div>
			<div class="bodycate" :class="{'dark':themeName=='dark'}">
				<router-link to="/c6">道史仙传</router-link>
			</div>
			<div class="bodycatef">
				<ul class="indexcateul">
					<li>
						<router-link to="/c30">神仙高道传</router-link>
					</li>
					<li>
						<router-link to="/c31">仙境名山志</router-link>
					</li>
				</ul>
			</div>
			<div class="bodycate" :class="{'dark':themeName=='dark'}">
				<router-link to="/mulu">目录索引</router-link>
			</div>

			<div class="main_shang">
			
				
			</div>
			<div id="main_xia"> 
				<h1><router-link to="/yjd">校对过的经文</router-link></h1><br /> 
				<h2>说明:</h2><br />
				<span>1.校对过的经文在标题左侧有标记，我校对或复校的标记为已校对，别人校对的标记为校对一次。</span><br /><br />
				<span>2.图片截图基本来自中华道藏电子版，原版是竖排从右到左的阅读顺序，多图请注意图片顺序。</span><br /><br />
				<span>3.我删除了部分经文中的注释，这类注释基本是解释其他版本写成什么。比如四库全书本写成什么等等。想看这类注释，请看页面右上角的图片版。</span>
				<br /> <br /> 
		 
					
				</div>
			<GoTop/>
		</div>
	</div>
</template>

<script>
	import GoTop from '@/components/gotop.vue'
	export default {
		name: 'HelloWorld',
		 components: {
					 GoTop
		},
		

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.main {
		display: flex;
		width: 100%;
		height: 100%;
		flex: 1;
	}

	.bodycate {
		margin-top: 1vh;
		margin-left: 0;
		margin-right: 0;
		margin-bottom: 0;
		height: 4.3vmax;
		font-weight: bold;
		padding: 0;
		display: flex;
		align-items: center;
	}
	.bodycatef.dark{
		border-bottom: 1px solid #808080;
	}

	.bodycatef {
		margin-top: 0;
		margin-left: 0vw;
		margin-right: 4vw;
		margin-bottom: 2vh;
		padding-bottom: 1.5vh;
		border-bottom: 1px solid #ebeaea;
	}

	.indexcateul {
		display: flex;
		flex-wrap: wrap;
	}

	.indexcateul li {
		margin-top: 1.5vh;
		margin-right: 5vmin;
	}

	.main_shang {
		margin-top: 3vh;
	}


</style>
